export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Latin2-46290899857e67460474184e88ad65d6.woff2";